import { useState, useEffect } from "react";

/**
 * @param {object} pagination - the API pagination object
 *   { data, count, totalDocs, limit, page, totalPages,
 *     pagingCounter, hasPrevPage, hasNextPage, prevPage, nextPage }
 * @param {function} onPageChange - (newPage: number) => void
 */
function Pagination({ pagination, onPageChange }) {
  const {
    page = 1,
    totalPages = 1,
    hasPrevPage = false,
    hasNextPage = false,
  } = pagination || {};

  const [goTo, setGoTo] = useState("");

  useEffect(() => {
    setGoTo(""); // clear input whenever page changes externally
  }, [page]);

  const changePage = (p) => {
    if (p < 1 || p > totalPages || p === page) return;
    onPageChange(p);
  };

  const handleGo = () => {
    const num = parseInt(goTo, 10);
    if (!isNaN(num)) changePage(num);
  };

  // Build a compact list of page numbers with ellipsis markers ("...")
  const getPageList = () => {
    const delta = 1; // pages shown around current page
    const range = [];
    const rangeWithDots = [];
    let last;

    for (let i = 1; i <= totalPages; i++) {
      if (
        i === 1 ||
        i === totalPages ||
        (i >= page - delta && i <= page + delta)
      ) {
        range.push(i);
      }
    }

    for (const i of range) {
      if (last) {
        if (i - last === 2) {
          rangeWithDots.push(last + 1);
        } else if (i - last > 2) {
          rangeWithDots.push("...");
        }
      }
      rangeWithDots.push(i);
      last = i;
    }

    return rangeWithDots;
  };

  const pageList = getPageList();

  return (
    <div
      style={{ display: "flex", justifyContent: "center" }}
      className="input-list diaplayflex"
    >
      <ul id="pageNumberContent" className="pages">
        <li id="prev">
          <a
            className={
              hasPrevPage ? "ng-star-inserted" : "disable ng-star-inserted"
            }
            onClick={() => hasPrevPage && changePage(page - 1)}
            style={{ cursor: hasPrevPage ? "pointer" : "default" }}
          >
            Prev
          </a>
        </li>

        {pageList.map((p, idx) =>
          p === "..." ? (
            <li
              key={`dots-${idx}`}
              id="pageNumber"
              className="ng-star-inserted"
            >
              <a
                className="btn ng-star-inserted"
                style={{ pointerEvents: "none" }}
              >
                ...
              </a>
            </li>
          ) : (
            <li key={p} id="pageNumber" className="ng-star-inserted">
              <a
                className={
                  p === page
                    ? "select ng-star-inserted"
                    : "btn ng-star-inserted"
                }
                style={
                  p === page ? { pointerEvents: "none" } : { cursor: "pointer" }
                }
                onClick={() => changePage(p)}
              >
                {p}
              </a>
            </li>
          ),
        )}

        <li id="next">
          <a
            className={
              hasNextPage ? "ng-star-inserted" : "disable ng-star-inserted"
            }
            onClick={() => hasNextPage && changePage(page + 1)}
            style={{ cursor: hasNextPage ? "pointer" : "default" }}
          >
            Next
          </a>
        </li>

        <input
          type="text"
          id="goToPageNumber"
          className="w-3/5 tex page-input"
          value={goTo}
          onChange={(e) => setGoTo(e.target.value.replace(/[^0-9]/g, ""))}
          onKeyDown={(e) => e.key === "Enter" && handleGo()}
          placeholder="Page"
        />
        <button
          id="goPageBtn"
          className="btn btn-highlight w-2/5 page-btn"
          onClick={handleGo}
        >
          GO
        </button>
      </ul>
    </div>
  );
}

export default Pagination;
